import LOCATIONPREFERENCE from 'data/mantechcar24/location-preference.json';
import { useI18n } from 'hooks/useI18n';
import {
  StyledCaption,
  StyledItem,
  StyledItems,
  StyledLegend,
  StyledLegendItem,
  StyledOfferedValue,
  StyledPrefersValue,
  StyledValueContainer
} from './LocationPreference.styled';

const LocationPreference: React.FC = () => {
  const { t } = useI18n('developer-career-report-2024');

  const maxValue = Math.max(
    ...LOCATIONPREFERENCE.map((obj) => {
      if (obj.prefersValue >= obj.offeredValue) {
        return obj.prefersValue;
      } else {
        return obj.offeredValue;
      }
    })
  );

  return (
    <>
      <StyledItems>
        {LOCATIONPREFERENCE.map((item) => (
          <StyledItem key={item.type}>
            <StyledCaption>{t(item.label)}</StyledCaption>
            <StyledValueContainer>
              <StyledPrefersValue
                style={
                  {
                    '--coeficient': item.prefersValue / maxValue
                  } as React.CSSProperties
                }
              />
              <StyledOfferedValue
                className={
                  item.offeredValue > item.prefersValue ? 'reverse' : ''
                }
                style={
                  {
                    '--coeficient': item.offeredValue / maxValue
                  } as React.CSSProperties
                }
              />
            </StyledValueContainer>
            <StyledLegend>
              <StyledLegendItem>
                {t('mantechcar24.benefits.location.preference')}:{' '}
                {item.prefersValue.toFixed(1)}%
              </StyledLegendItem>
              <StyledLegendItem>
                {t('mantechcar24.benefits.location.offer')}:{' '}
                {item.offeredValue.toFixed(1)}%
              </StyledLegendItem>
            </StyledLegend>
          </StyledItem>
        ))}
      </StyledItems>
    </>
  );
};

export default LocationPreference;
